import { render, staticRenderFns } from "./salesInvoiceActive.vue?vue&type=template&id=70b99033&scoped=true"
import script from "./salesInvoiceActive.vue?vue&type=script&lang=js"
export * from "./salesInvoiceActive.vue?vue&type=script&lang=js"
import style0 from "./salesInvoiceActive.vue?vue&type=style&index=0&id=70b99033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b99033",
  null
  
)

export default component.exports